module.exports = __webpack_public_path__ + "img/20180815_150119_056.52ce54df.jpg";